




















import { delay } from "lodash";
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import Control from "./Control.vue";

export type NextCardDirection = "up" | "down" | "left" | "right";

@Component({ components: { Control } })
export default class Card extends Vue {
  // Should be kept in sync with $pointer-section.
  private static readonly pointerSectionSize = 50;

  private displayBody = true;

  @Prop({ default: undefined })
  private nextCardDirection: NextCardDirection | undefined;

  @Prop({ required: true })
  private pointerAnimationDuration: number;

  private mounted() {
    const cardBody = this.$refs.cardBody as Element;
    const cardContentLayout = this.$refs.cardContentLayout as Element;

    const bodyHeight = cardBody.clientHeight;
    const layoutHeight = cardContentLayout.clientHeight;
    const tooTall = bodyHeight + Card.pointerSectionSize * 2 >= layoutHeight;

    this.displayBody = !tooTall;
  }

  private get cardPointerStyleObject() {
    return {
      "animation-duration": `${this.pointerAnimationDuration}s`,
    };
  }

  private get contentFitsCurrentSize(): boolean {
    const cardBody = this.$refs.cardBody as Element;
    const cardContentLayout = this.$refs.cardContentLayout as Element;

    console.log({cardBody, cardContentLayout});
    return false;
  }

  private get cardPointer(): string {
    switch (this.nextCardDirection) {
      case undefined: return "";
      case "up": return "expand_less";
      case "down": return "expand_more";
      case "left": return "chevron_left";
      case "right": return "chevron_right";
      default: throw new Error(`Invalid direction: ${this.nextCardDirection}`);
    }
  }
}
